"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "chiari": {
    "06939e3f": [{
      "hkey": "5671bf83",
      "slug": "chiari",
      "name": "Chiari",
      "primary": true,
      "skipSearch": false
    }],
    "san-bernardino": [{
      "hkey": "5671bf83",
      "slug": "chiari",
      "name": "Chiari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "da5b1756": [{
      "hkey": "5671bf83",
      "slug": "chiari",
      "name": "Chiari",
      "primary": true,
      "skipSearch": false
    }],
    "san-bernardo": [{
      "hkey": "5671bf83",
      "slug": "chiari",
      "name": "Chiari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "164dcda2": [{
      "hkey": "5671bf83",
      "slug": "chiari",
      "name": "Chiari",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "5671bf83",
      "slug": "chiari",
      "name": "Chiari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;